import {
  REQUEST_WAS_TRIALS,
  RESPONSE_WAS_TRIALS,
  FAILURE_WAS_TRIALS,
  SORT_WAS_CLINICAL_TRIAL,
  WAS_CLINICAL_TRIAL_MORE_REQUEST,
  WAS_CLINICAL_TRIAL_MORE_FAILURE,
  WAS_CLINICAL_TRIAL_MORE_RESPONSE,
  CHANGE_WAS_CLINICAL_TRIAL_FILTER
} from "../../../actions/types";
import { combineReducers } from "redux";

import ClinicalTrialFilterReducer from "./ClinicalTrialFilterReducer";

const defaultKeywords = ``;

const initialState = {
  keyword: defaultKeywords,
  isFetching: false,
  results: [],
  graph: [],
  sortItem: { value: "CITATION", label: "Citation" },
  error: false,
  isInitalScreen: true,
  statusCode: 0,
  totalTrials: 0,
  from: 0,
  size: 10,
  isMoreResult: true,
  isMoreResultFetching: false,
  activePage: 1,
  totalInvestigators: 0,
  totalSites: 0
};

const setFetching = (state, action) => {
  return {
    ...state,
    isFetching: true,
    results: [],
    graph: [],
    isInitalScreen: false,
    statusCode: 0,
    totalTrials: 0,
    totalEnrollments: 0,
    totalSponsors: 0,
    activePage: 1,
    from: 0,
    size: 10,
    isMoreResult: true,
    totalInvestigators: 0,
    totalSites: 0
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
    totalTrials: 0,
    totalEnrollments: 0,
    totalSponsors: 0,
    totalInvestigators: 0,
    totalSites: 0,
    graph: []
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || [];
  let totalTrials = action.payload.totalTrials || 0;
  let totalInvestigator = action.payload.totalInvestigators || 0;
  let totalSite = action.payload.totalSites || 0;
  let totalEnrollments = action.payload.totalEnrollments || 0;
  let totalSponsors = action.payload.totalSponsors || 0;
  let statusCode = action.payload.statusCode;
  let graph = action.payload.graph || [];
  let isMoreResult = true;

  if (totalTrials <= 10) {
    isMoreResult = false;
  }

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    totalTrials,
    totalEnrollments: totalEnrollments,
    totalSponsors: totalSponsors,
    isMoreResult,
    statusCode,
    totalInvestigator,
    totalSite,
    graph
  };
};

const setClinical = (state, action) => {
  let sortItem = action.payload.results || [];

  return {
    ...state,
    sortItem
  };
};

const setMoreResultResponse = (state, action) => {
  let from = action.payload.from || 0;
  let results = action.payload.results || [];
  let isMoreResult = true;
  let activePage = action.payload.activePage || 1;

  if (results.length == 0) {
    isMoreResult = false;
  }
  results = [...results];

  return {
    ...state,
    results,
    from,
    isMoreResult,
    isMoreResultFetching: false,
    activePage: activePage
  };
};

const setMoreResultRequest = (state, action) => {
  return {
    ...state,
    isMoreResultFetching: true
  };
};

const setMoreResultFailure = (state, action) => {
  return {
    ...state,
    isMoreResultFetching: false
  };
};

const updateKeyword = (state, action) => {
  let { terms = [] } = action.payload;
  terms = terms.map(l => l.value);
  let keyword = terms.join(", ");

  if (!keyword) {
    keyword = state.keyword;
  }
  return {
    ...state,
    keyword
  };
};

const ClinicalTrialReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_WAS_TRIALS:
      return setFetching(state, action);
      break;

    case RESPONSE_WAS_TRIALS:
      return setResults(state, action);

    case FAILURE_WAS_TRIALS:
      return setFailure(state, action);

    case SORT_WAS_CLINICAL_TRIAL:
      return setClinical(state, action);

    case WAS_CLINICAL_TRIAL_MORE_REQUEST:
      return setMoreResultRequest(state, action);

    case WAS_CLINICAL_TRIAL_MORE_RESPONSE:
      return setMoreResultResponse(state, action);

    case WAS_CLINICAL_TRIAL_MORE_FAILURE:
      return setMoreResultFailure(state, action);

    case CHANGE_WAS_CLINICAL_TRIAL_FILTER:
      return updateKeyword(state, action);

    default:
      return state;
      break;
  }
};

export default combineReducers({
  Filters: ClinicalTrialFilterReducer,
  Results: ClinicalTrialReducer
});
